export var PROJECT_FETCH_REQUEST = 'PROJECT_FETCH_REQUEST';
export var PROJECT_FETCH_SUCCESS = 'PROJECT_FETCH_SUCCESS';
export var PROJECT_FETCH_FAIL = 'PROJECT_FETCH_FAIL';
